module.exports = __webpack_public_path__ + "static/img/ic_logo_jns_login.9e8a1ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_logo_jns_login.png
// module id = S3Yl
// module chunks = 0